import {Box, Occupancy} from "@variocube/app-api";
import * as React from "react";
import {useCallback} from "react";
import {Item} from "../types";
import {BoxAccess, usePlatform, usePreventDeactivate} from "@variocube/cube-ui";
import {useLocalization} from "../../i18n";

export interface StorageBoxAccessProps {
    occupancy: Occupancy;
    box: Box;
    item: Item;
    onDone: () => void;
}

export function StorageBoxAccess({occupancy, box, item, onDone}: StorageBoxAccessProps) {

    const platform = usePlatform();
    const {t} = useLocalization();

    const handleConfirm = useCallback(async () => {
        try {
            await platform.confirmOccupancy(occupancy.uuid);
            onDone();
        }
        catch (error) {
            console.error("Error confirming occupancy", error);
        }
    }, [platform, occupancy, onDone]);

    const handleCancel = useCallback(async () => {
        try {
            await platform.cancelOccupancy(occupancy.uuid);
            onDone();
        }
        catch (error) {
            console.error("Error cancelling occupancy", error);
        }

    }, [platform, occupancy, onDone]);

    usePreventDeactivate();

    return (
        <BoxAccess
            boxes={box}
            onCancel={handleCancel}
            allowCancelWhenOpen
            platform={platform}
            onConfirm={handleConfirm}
            boxOpenTitle={t("StoreItem")}
            boxOpenMessage={t("StoreItemMessage", {item: item.name, boxNumber: box.number})}
            confirmTitle={t("ConfirmStorage")}
            confirmMessage={t("ConfirmStorageMessage", {item: item.name, boxNumber: box.number})}
            strings={t}
            timeout={true}
            onTimeout={'cancel'}
        />
    );
}